import dates from "core/dates";
import { useQueryDAU, useQueryFloat, useQueryMAU, useQueryMonetizedTraffic, useQueryRevenue, useQueryTotalAccounts } from "./data";


const formatter = (date: number) => {
	const value = new Date(date).getHours();
	const hour = Math.max(0, Math.min(23, Math.round(value)));
	const isMidnight = hour === 0;
	const isNoon = hour === 12;
	const displayHour = hour % 12;
	const suffix = hour < 12 ? "AM" : "PM";

	if (isMidnight) return "0AM";
	if (isNoon) return "12PM";
	return `${displayHour}${suffix}`;
};
const min = dates.startOfDay(new Date()).getTime();
const max = dates.set(min, { hours: 23, minutes: 59, seconds: 59 }).getTime();

export const useDAU = () => {
	const dau = useQueryDAU();

	return { ...dau, min, max, formatter };
};

export const useMAU = useQueryMAU;
export const useTotalAccounts = useQueryTotalAccounts;

export const useRevenue = () => {
	const revenue = useQueryRevenue();
	return { ...revenue, min, max, formatter };
};

export const useFloat = () => {
	const float = useQueryFloat();

	const getColor = (value?: number) => {
		if (value === null || value === undefined) return "#ef476f";

		if (value < 15) return "#e63946";
		else if (value < 50) return "#f4a261";
		else return "#2a9d8f";
	};

	return { ...float, getColor };
};

export const useMonetizedTraffic = () => {
	const traffic = useQueryMonetizedTraffic();

	return { ...traffic };
};